import { render, staticRenderFns } from "./activity_sign.vue?vue&type=template&id=93ffbcc8&scoped=true&"
import script from "./activity_sign.vue?vue&type=script&lang=js&"
export * from "./activity_sign.vue?vue&type=script&lang=js&"
import style0 from "./activity_sign.vue?vue&type=style&index=0&id=93ffbcc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ffbcc8",
  null
  
)

export default component.exports